import styled from 'styled-components'
import { Box } from '~/components/Box'

export const StyledFailureInfo = styled.div`
  color: ${({ theme }) => theme.colors.textTertiary};
  font-weight: 400;
  line-height: 160%;
  font-size: 12px;

  ul {
    padding-left: 20px;
  }
`

export const StyledResultBox = styled(Box)<{ $pad?: boolean }>`
  ${({ $pad }) => $pad && `padding: 0 10px;`}
`
